var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2427 12.2427C13.3679 11.1174 14.0001 9.59131 14.0001 8.00001C14.0001 6.4087 13.3679 4.88256 12.2427 3.75734C11.1175 2.63211 9.59135 1.99997 8.00004 1.99997C6.40873 1.99997 4.8826 2.63211 3.75737 3.75734M12.2427 12.2427C11.1175 13.3679 9.59135 14 8.00004 14C6.40873 14 4.8826 13.3679 3.75737 12.2427C2.63214 11.1174 2 9.59131 2 8.00001C2 6.4087 2.63214 4.88256 3.75737 3.75734M12.2427 12.2427L3.75737 3.75734",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanOutline);
export default __webpack_public_path__ + "static/media/BanOutline.7a355e8f9f30bdb25ce24d11866b7f5c.svg";
export { ForwardRef as ReactComponent };